import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './BusinessPage.css';

const BusinessPage = () => {
    useEffect(() => {
        document.title = "Marlo - For Business";
    }, []);

    // 打开 App Store 下载页
    const handleDownloadApp = () => {
        window.open('https://apps.apple.com/us/app/marlo-connect-meet-nearby/id6450737280?l=zh-Hans-CN', '_blank');
    };

    // 打开邮件客户端
    const handleEmailClick = () => {
        window.location.href = 'mailto:Hello@himarlo.com';
    };

    return (
        <div className="business-page">
            <Header />
            
            {/* 主要内容 */}
            <div className="business-content">
                {/* 背景图片 */}
                <div className="business-bg-header"></div>
                {/* 标题文字组 */}
                <div className="business-title-group">
                    <div className="business-title-line1">
                        Grow Your Community.
                    </div>
                    <div className="business-hero-subtitle">
                        Reach new people through local deals, events, and community.
                    </div>
                </div>
                
                {/* 功能卡片组 */}
                <div className="business-cards-container">
                    {/* 第一个卡片 */}
                    <div className="business-card">
                        <div className="business-card-header">
                            <img 
                                src={require('../images/business/user.png')} 
                                alt="User" 
                                className="business-card-icon"
                            />
                            <span className="business-card-title">Reach Nearby People</span>
                        </div>
                        <div className="business-card-description">
                            Connect with people nearby through local deals shown within a 4-mile radius. Bring more visitors through your door—without paying for every post.
                        </div>
                    </div>
                    
                    {/* 分隔线 */}
                    <div className="business-divider"></div>
                    
                    {/* 第二个卡片 */}
                    <div className="business-card">
                        <div className="business-card-header">
                            <img 
                                src={require('../images/business/rocket.png')} 
                                alt="Rocket" 
                                className="business-card-icon"
                            />
                            <span className="business-card-title">Create Events That Connect</span>
                        </div>
                        <div className="business-card-description">
                            Publish public or private events with city-wide visibility. Every event includes its own built-in chat to help people connect before, during, and after.
                        </div>
                    </div>
                    
                    {/* 分隔线 */}
                    <div className="business-divider"></div>
                    
                    {/* 第三个卡片 */}
                    <div className="business-card">
                        <div className="business-card-header">
                            <img 
                                src={require('../images/business/flame.png')} 
                                alt="Flame" 
                                className="business-card-icon"
                            />
                            <span className="business-card-title">Build Your Community</span>
                        </div>
                        <div className="business-card-description">
                            Turn first-time visitors into long-term community members. Share updates, launch new events, and keep people coming back—all in one place.
                        </div>
                    </div>
                </div>
                
                {/* 第二个模块 - 服务计划 */}
                <div className="business-service-section">
                    <div className="business-service-title">
                        Everything You Need to Grow.
                    </div>
                    <div className="business-service-description">
                        From local deals to events, community, and insights—everything works together to help your business grow.
                    </div>
                </div>

                {/* Pad 端专用模块 - 服务计划 */}
                <div className="business-pad-service-section">
                    <div className="business-pad-service-title">
                        Everything You Need to Grow.
                    </div>
                    <div className="business-service-description">
                        From local deals to events, community, and insights—everything works together to help your business grow.
                    </div>
                    
                    {/* Marlo Business 卡片 */}
                    <div className="business-plan-card business-pad-card business-pad-plan-card">
                        <div className="card-title">Marlo Business</div>
                        <div className="card-subtitle card-subtitle-pro">Everything you need to grow — in one subscription.</div>
                        <div className="card-features business-plan-features">
                            <div className="feature-item">
                                <span className="feature-text">📍 Local Deals: Reach people nearby with unlimited deals shown within a 4-mile radius—no per-post fees.</span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-text">🎉 Create Events: Publish public or private events with city-wide visibility. Every event comes with its own built-in chat.</span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-text">💬 Community Chat: Keep your community connected before, during, and after every event.</span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-text">🏪 Business Page: Give people one place to discover your deals, events, photos, and community.</span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-text">📈 Real-Time Insights: See what’s driving engagement with views, scans, and deal claims.</span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-text">🎟 Built-in Ticketing (Coming Soon): Sell tickets with QR check-in—no third-party ticketing fees.</span>
                            </div>
                        </div>
                        <div className="card-divider business-plan-divider"></div>
                        <div className="card-price">
                            <span className="price-amount">$39.99</span>
                            <span className="price-period">/month</span>
                        </div>
                        <button className="card-button card-button-pro card-button-pad" onClick={handleDownloadApp}>Download the App</button>
                    </div>
                </div>
                
                {/* 第三个模块 - 带背景的卡片组 */}
                <div className="business-card-section">
                    <div className="business-card-group">
                        {/* Marlo Business 卡片 */}
                        <div className="business-plan-card business-white-card business-single-card">
                        <div className="card-title">Marlo Business</div>
                        <div className="card-subtitle card-subtitle-pro">Everything you need to grow — in one subscription.</div>
                        <div className="card-features business-plan-features">
                            <div className="feature-item">
                                <span className="feature-text">📍 Local Deals: Reach people nearby with unlimited deals shown within a 4-mile radius—no per-post fees.</span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-text">🎉 Create Events: Publish public or private events with city-wide visibility. Every event comes with its own built-in chat.</span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-text">💬 Community Chat: Keep your community connected before, during, and after every event.</span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-text">🏪 Business Page: Give people one place to discover your deals, events, photos, and community.</span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-text">📈 Real-Time Insights: See what’s driving engagement with views, scans, and deal claims.</span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-text">🎟 Built-in Ticketing (Coming Soon): Sell tickets with QR check-in—no third-party ticketing fees.</span>
                            </div>
                        </div>
                        <div className="card-divider business-plan-divider"></div>
                        <div className="card-price">
                            <span className="price-amount">$39.99</span>
                            <span className="price-period">/month</span>
                        </div>
                        <button className="card-button card-button-pro " onClick={handleDownloadApp}>Download the App</button>
                    </div>
                    </div>
                </div>

                {/* 手机端专用模块 - 服务计划 */}
                <div className="business-mobile-service-section">
                    <div className="business-mobile-service-title">
                        Everything You Need to Grow.
                    </div>
                    <div className="business-service-description">
                        From local deals to events, community, and insights—everything works together to help your business grow.
                    </div>
                    
                    {/* Marlo Business 卡片 */}
                    <div className="business-plan-card business-mobile-card business-mobile-plan-card">
                        <div className="card-title">Marlo Business</div>
                        <div className="card-subtitle card-subtitle-pro">Everything you need to grow — in one subscription.</div>
                        <div className="card-features business-plan-features">
                            <div className="feature-item">
                                <span className="feature-text">📍 Local Deals: Reach people nearby with unlimited deals shown within a 4-mile radius—no per-post fees.</span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-text">🎉 Create Events: Publish public or private events with city-wide visibility. Every event comes with its own built-in chat.</span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-text">💬 Community Chat: Keep your community connected before, during, and after every event.</span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-text">🏪 Business Page: Give people one place to discover your deals, events, photos, and community.</span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-text">📈 Real-Time Insights: See what’s driving engagement with views, scans, and deal claims.</span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-text">🎟 Built-in Ticketing (Coming Soon): Sell tickets with QR check-in—no third-party ticketing fees.</span>
                            </div>
                        </div>
                        <div className="card-divider business-plan-divider"></div>
                        <div className="card-price">
                            <span className="price-amount">$39.99</span>
                            <span className="price-period">/month</span>
                        </div>
                        <button className="card-button card-button-pro card-button-mobile" onClick={handleDownloadApp}>Download the App</button>
                    </div>
                </div>
                
                {/* 第四个模块 - 联系我们 */}
                <div className="business-contact-section">
                    {/* 光晕效果组 */}
                    <div className="contact-glow-group">
                        {/* 蓝色光晕 */}
                        <div className="contact-glow-blue"></div>
                        {/* 绿色光晕 */}
                        <div className="contact-glow-green"></div>
                    </div>
                    
                    {/* 文字组 */}
                    <div className="contact-text-group">
                        <div className="contact-eyebrow">
                            Ready to Bring in New Customers?
                        </div>
                        <div className="contact-main-text">
                            Join the local merchants growing<br className="contact-pc-br" />on Marlo — first 3 months free.
                        </div>
                        <div className="contact-email-text">
                            Questions? Email us <span className="email-highlight-container" onClick={handleEmailClick} style={{ cursor: 'pointer' }}>
                                <span className="email-highlight">Hello@himarlo.com</span>
                                <span className="email-underline"></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            
            <Footer />
        </div>
    );
};

export default BusinessPage;
